import React from 'react';
import { Fire } from './fire';
import { Career } from './career';
import { Communication } from './communication';
import { Diploma } from './diploma';
import { Gpt } from './gpt';

export function BenefitIcon({ type, isSm }) {
  switch (type) {
    case 'fire':
      return <Fire isSm={isSm} />;
    case 'career':
      return <Career isSm={isSm} />;
    case 'communication':
      return <Communication isSm={isSm} />;
    case 'diploma':
      return <Diploma isSm={isSm} />;
    case 'gpt':
      return <Gpt isSm={isSm} />;
    default:
      return null;
  }
}
